import { useEffect, useState } from 'react'
import styles from './EditPlatformCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import EditPlatformCardShortInformation from '../../components/EditPlatformCardShortInformation/EditPlatformCardShortInformation'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import EditPlatformCardFilesBlock from '../../components/EditPlatformCardFilesBlock/EditPlatformCardFilesBlock'
import UploadPhotoComponent from '../../components/UploadPhotoComponent/UploadPhotoComponent'
import exit from '../../assets/icons/trash.svg'
import { UploadImagesType } from '../../types'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import {
  blockPlatform,
  changePlaceDescription,
  deleteCurrentFileFromPlatform,
  deleteCurrentPlaces,
  getCurrentPlaces,
  pushNewFilesToPlatform,
} from '../../redux/actions/placesAction'
import Loader from '../../components/UI/Loader/Loader'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useNavigate, useParams } from 'react-router-dom'
import { waitTimer } from '../../utils/waitTimer'
import s from '../../styles/common/Form.module.css'
import { useMediaQuery } from 'react-responsive'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import TitleBlockForEditPages from '../../components/TitleBlockForEditPages/TitleBlockForEditPages'
import { useToast } from '../../context/ToastContext'

const EditPlatformCardPage = () => {
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any[]>([])
  const [visible, setVisible] = useState<boolean>(false)
  const [platformNetworkError, setPlatformNetworkError] = useState<boolean>(false)
  const { showSuccess, showError } = useToast()
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const [platformConfirm, setPlatformConfirm] = useState<boolean>(false)

  let { isLoading, currentPlace, errorImage } = useAppSelector((state) => state.places)

  const { token } = useAppSelector((state) => state.auth)

  const { platformId } = useParams<{ platformId: string }>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const onChangeSwipeCheckboxHandler = async (checked: boolean) => {
    await dispatch(
      blockPlatform({
        placeId: String(currentPlace.id),
        isBlocked: !checked,
      }),
    )

    await dispatch(getCurrentPlaces({ placeId: platformId, token }))
  }

  const onDeletePopup = () => {
    setVisible(true)
  }

  const onDeletePlatform = async () => {
    const resultAction = await dispatch(deleteCurrentPlaces({ placeId: platformId, token }))

    if (deleteCurrentPlaces.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении зала')
    } else {
      navigate(-2)
      showSuccess('Зал успешно удален')
    }
  }

  const handleDeleteImage = (e: any) => {
    const targetIndex = e.target.dataset.imgindex * 1
    setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
  }

  const onUploadNewImages = async () => {
    const formData = new FormData()

    if (photosFile.length > 10) {
      showError('Вы можете загрузить максимум 10 картинок')

      return
    }

    if (photosFile.length !== 0) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }

      const resultAction = await dispatch(
        pushNewFilesToPlatform({ placeId: String(currentPlace.id), formData, token }),
      )

      if (pushNewFilesToPlatform.rejected.match(resultAction)) {
        showError('Произошла ошибка при добавлении файлов')
      } else {
        showSuccess('Файлы успешно добавлены')
        setPhotosFile([])
        setPhotos([])
        await dispatch(getCurrentPlaces({ placeId: platformId, token }))
      }
    }
  }

  const onDeleteImageFromServer = async (image: string) => {
    const resultAction = await dispatch(
      deleteCurrentFileFromPlatform({
        token,
        placeId: String(currentPlace.id),
        filesToDelete: [image],
      }),
    )

    if (deleteCurrentFileFromPlatform.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении файлов')
    } else {
      showSuccess('Файлы успешно удалены')
      await dispatch(getCurrentPlaces({ placeId: String(currentPlace.id), token }))
    }
  }

  useEffect(() => {
    dispatch(getCurrentPlaces({ placeId: platformId, token }))
  }, [platformId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.editPlatformCard}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
          title='Удаление зала'
          description='Хотите удалить данный зал ?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeletePlatform}
          deleteError={platformNetworkError}
        />
      </CustomModal>
      <Navbar />
      <div className={styles.imageContainer}>
        <HeaderForCard
          deleteButton={
            <CustomButton
              iconSrc={IconTrashRed}
              className={styles.deleteBtn}
              title={isMobile ? '' : 'Удалить зал'}
              onClick={onDeletePopup}
            />
          }
          title={currentPlace.name}
        />
      </div>
      <div className={styles.buttonBlock}>
        <TitleBlockForEditPages
          title={'Изображения'}
          disabled={false}
          handleSubmit={onUploadNewImages}
        />
      </div>

      <div className={styles.imageUpload}>
        <UploadPhotoComponent
          editMode
          photos={photos}
          photosFile={photosFile}
          setPhotos={setPhotos}
          widthOneImageContainer={245}
          widthOneGapOfImageContainer={20}
          setPhotosFiles={setPhotosFile}
        >
          <div className={styles.imagesWrapper}>
            {currentPlace.images.length > 0 &&
              currentPlace.images.map((image, index) => {
                return (
                  <div className={styles.imagesContainer} key={index} data-imgindex={index + 100}>
                    <div className={styles.imageExitContainer}>
                      <img
                        className={styles.imageExit}
                        src={exit}
                        alt='exit'
                        onClick={() => onDeleteImageFromServer(image)}
                        data-imgindex={index}
                      />
                    </div>
                    <img
                      className={styles.image}
                      src={`${process.env.REACT_APP_BASE_URL_IMAGES}${image}`}
                      alt={image}
                    />
                  </div>
                )
              })}
            {photos.length > 0 &&
              photos.map((photo, index) => {
                return (
                  <div className={styles.imagesContainer} key={index} data-imgindex={index}>
                    <div className={styles.imageExitContainer}>
                      <img
                        className={styles.imageExit}
                        src={exit}
                        alt='exit'
                        onClick={handleDeleteImage}
                        data-imgindex={index}
                      />
                    </div>
                    <img className={styles.image} src={photo?.src} alt={photo.name} />
                  </div>
                )
              })}
          </div>
        </UploadPhotoComponent>
        <>
          {errorImage && <p className={`${s.errorValidation} ${s.networkError}`}>{errorImage}</p>}
        </>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <EditPlatformCardShortInformation
            onChangeSwipeCheckboxHandler={onChangeSwipeCheckboxHandler}
            platformData={currentPlace}
          />
          <EditPlatformCardFilesBlock platformData={currentPlace} />
        </div>
        {/* <BlockAndDeletePanel
          blockText='Заблокирована'
          isBlocked={currentPlace.isBlocked}
          buttonTitle='Удалить зал'
          checkBoxTitle='Заблокировать зал'
          onChangeHandler={onChangeSwipeCheckboxHandler}
          onDeleteHandler={onDeletePopup}
        /> */}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default EditPlatformCardPage
